import { Typography } from "@material-ui/core";
import { IAuditLogEntry } from "../../../../types";

export const CropAuditDelete = ({ oldData }: IAuditLogEntry) => {
  return <Typography>Deleted the Crop "{oldData.name}"</Typography>;
};

export default CropAuditDelete;
